(function($){
  $(function() {
    		
$(document).ready(function(){
  
 
  	var customer_posted = getUrlParameter('customer_posted');
  
    if(customer_posted == 'true') {
      
        $.magnificPopup.open({
                items: {
                    src: '#confirmation-popup'
                },
                type: 'inline'
            }, 0);
      }
  
  
  /*
  $('.open-popup-link').magnificPopup({
    type:'inline',
    midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
  */
  
  if(jQuery(".contact-form .note.form-success").length) {
    var expiry = new Date(Date.now() + 5 * 24 * 60 * 60 * 1000);

    localStorage.setItem("wetheme-popup", JSON.stringify({
      expiry: expiry.toISOString(),
    }));
  }
  
  setTimeout(function(){ 
    if($('.bundler-target-element').length) {
      if($('.bundler-target-element .bndlr-new-price[data-currency-usd="$0.00"]').length && $('.bundler-target-element .free-item').length == 0) {
    
         $('.bundler-target-element .bndlr-new-price[data-currency-usd="$0.00"]').closest('.bndlr-product').find('.bndlr-product-title').after('<div class="free-item">Free</div>');
        
      }
    }
  }, 1000);
  
  
  if($('.template-product .product-medias .product-medias__thumbnails').length) {
  	String.prototype.filename=function(extension){
      var s= this.replace(/\\/g, '/');
      s= s.substring(s.lastIndexOf('/')+ 1);
      return extension? s.replace(/[?#].+$/, ''): s.split('.')[0];
    }
    
    var secondImage = $('.template-product .product-medias .product-medias__thumbnails .product-medias__thumbnail:nth-child(2) img');
    var secondImageSRC = secondImage.attr('src');

    console.log(secondImageSRC.filename());
    if(secondImageSRC.includes("-hover")) {
    	secondImage.closest('a').css('display', 'none');
    }
  }
  
  if( $('.grid-view-item').length ) {
    $(document).on('mouseenter', '.grid-view-item', function(){
    	$(this).addClass('hovering');
      	$(this).find('.hidden').css({'opacity': 1, 'z-index': 4 });
      
    })
    $(document).on('mouseleave', '.grid-view-item', function(){
    	$(this).removeClass('hovering');
      	$(this).find('.hidden').css({'opacity': 0, 'z-index': 4 });
      
    })
  }
  
  $('.tabs .tab-link').on('click', function(e){
    e.preventDefault();
    var t = $(this).attr('href');

    if($(this).hasClass('active') == false){
      $('.tabs .tab-link').removeClass('active');
      $('.tab-info').removeClass('active').fadeOut('slow');         
      $(this).addClass('active');
      $(t).addClass('active').fadeIn('slow');
    }
  });
  
  
  if($('.grid-gallery').length) {
    var $grid = $('.grid-gallery').imagesLoaded( function() {
      // init Masonry after all images have loaded
      $grid.masonry({
        // options...
      });
    });
  }
  
  if($('.tags-list').length) {
  	var windowUrl = window.location.pathname;
    $('.tag-link').each(function(){
      var tagLinks = $(this).attr('href');
      if(windowUrl == tagLinks){
      	$(this).addClass('active');
      }
    })
  }
  
	set_equal_height();		
  
  if($('.history-timeline').length) {
  	$('.history-timeline').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
  if($('.products-gallery').length) {
  	$('.products-gallery').slick({
      dots: false,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
  
  
});

$(window).resize(function() {
set_equal_height();
});

$(window).on('load', function(){
set_equal_height();
  
  setTimeout(function(){ 
    if($('.bundler-target-element').length) {
      if($('.bundler-target-element .bndlr-new-price[data-currency-usd="$0.00"]').length && $('.bundler-target-element .free-item').length == 0) {
    
         $('.bundler-target-element .bndlr-new-price[data-currency-usd="$0.00"]').closest('.bndlr-product').find('.bndlr-product-title').after('<div class="free-item">Free</div>');
        
      }
    }
  }, 1000);
});
	});


})(jQuery);
var equalheight = function(container) {
  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = [],
      $el,
      topPosition = 0,
      currentDiv;

  $(container).each(function() {
    $el = $(this);
    $el.height('auto');
    topPosition = $el.position().top;
    if (currentRowStart < topPosition - 1 || currentRowStart > topPosition + 1) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs = [];
      currentRowStart = topPosition;
      currentTallest = $el.outerHeight();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = Math.max(currentTallest, $el.outerHeight());
    }
  });

  for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
    rowDivs[currentDiv].css('height', currentTallest);
  }
};

function set_equal_height() {
  equalheight('.homepage-featured-products-grid .homepage-featured-grid-item');
  equalheight('.bndlr-product-qn-container .bndlr-product-title');
}
  

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};